export function isvalidUsername(str) {
  const validRegexp = /^[a-zA-Z0-9_]+$/g
  return validRegexp.test(str)
}

/* 合法uri */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * 校验文件类型是否合法
 * @param {Array} allowList 允许的类型列表，不包含 . 的后缀名
 * @param {String} fileName 文件名
 */
export function validateFileExt(allowList, fileName) {
  const ext = fileName.slice(fileName.lastIndexOf('.') + 1)
  if (!allowList.includes(ext)) {
    return false
  }

  return true
}

/**
 * 校验 固话 或 手机号 是否合法
 * @param {String} value 待校验数据
 */
export function phoneValidate(value) {
  if (!value) return false
  if (Number.isNaN(Number(value))) return false

  return /^(([0+]\d{2,3}-)?(0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/.test(value) || /^1(?:[3578][0-9]|6[2567]|4[014-9]|9[1-35-9])\d{8}$/.test(value)
}

/**
* 校验 qq 是否合法
* @param {String} value 待校验数据
*/
export function qqValidate(value) {
  if (!value) return false
  if (Number.isNaN(Number(value))) return false

  return /^[1-9][0-9]{4,11}$/.test(value)
}

const emailReg = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
export function emailValidate(email) {
  if (!email) { return false }

  if (email.length > 254) { return false }

  var valid = emailReg.test(email)
  if (!valid) { return false }

  // Further checking of some things regex can't handle
  var parts = email.split('@')
  if (parts[0].length > 64) { return false }

  var domainParts = parts[1].split('.')
  if (domainParts.some(function(part) { return part.length > 63 })) { return false }

  return true
}

/**
 * 校验歌曲名，仅允许中英文常用符号，不包含特殊字符
 * @param {*} trackName
 * @returns
 */
export function trackNameValidate(trackName) {
  return /^[\u4E00-\u9FA5A-Za-z0-9（）()《》【】、，,_\-\-—\\/\s]+$/.test(trackName)
}

/**
 * 校验身份证号
 */
export function validateIdNumber(idNumber) {
  var pattern = /^[1-9]\d{5}(18|19|20)\d{2}(0\d|1[0-2])([0-2]\d|3[0-1])\d{3}[0-9Xx]$/
  if (!pattern.test(idNumber)) {
    return false
  }

  // 验证身份证号的校验码
  const factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  const checkCodeDict = {
    0: '1',
    1: '0',
    2: 'X',
    3: '9',
    4: '8',
    5: '7',
    6: '6',
    7: '5',
    8: '4',
    9: '3',
    10: '2'
  }

  const idNumberWithoutCheckCode = idNumber.slice(0, 17)
  const checkCode = idNumber.charAt(17).toUpperCase()

  // 计算校验码
  let checksum = 0
  for (let i = 0; i < 17; i++) {
    checksum += parseInt(idNumberWithoutCheckCode.charAt(i)) * factors[i]
  }

  return checkCode === checkCodeDict[checksum % 11]
}

/**
 * 校验邮政编码
 */
export function validatePostalCode(postalCode) {
  const pattern = /^[1-9]\d{5}$/
  return pattern.test(postalCode)
}
